export const AUTHORIZE_KEYS = [
  "client_id",
  "grant_type",
  "redirect_uri",
  "response_type",
  "state",
]
